export const UBMFlagSet = 'ubm_fe';

export enum FeatureFlags {
  Test = 'test_split_implementation',
  Mfa_Modal = 'DD-3152-MFA_Modal_Rollout',
  DeactivateTopListingModal = 'ASR-1453_Deactivate-Top-Listing-Modal',
}
